import { useMemo } from "react";

import { Roles } from "@utils/settings";
import { useFetchDietitianAccountQuery } from "./queries/settings/useFetchDietitianAccountQuery";
import { ClinicType } from "@client/settings/getDietitianAccountAPI";
import { useClinic } from "./useClinic";

export const useUserRoles = () => {
  const { account } = useFetchDietitianAccountQuery();
  const { clinic } = useClinic();
  const isAdmin = Boolean(account?.roles?.includes(Roles.DIETITIAN_OWNER));
  const isAdminClinicMember = clinic?.id === 1;
  const isBecompleatMember = clinic?.id === 3;
  const isSchool = clinic?.type === ClinicType.SCHOOL;
  return useMemo(
    () => ({
      isSuperAdmin: isAdmin && isAdminClinicMember,
      isAdminClinicMember,
      isClinicAdmin: isAdmin,
      isWorker: Boolean(account?.roles?.includes(Roles.DIETITIAN_WORKER)),
      isAssistant: Boolean(account?.roles?.includes(Roles.DIETITIAN_ASSISTANT)),
      isPatient: Boolean(account?.roles?.includes(Roles.PATIENT)),
      isSchool,
      canViewAllPatients: account?.permissions?.canViewAllPatients,
      isBecompleatMember,
    }),
    [account, isAdmin, isAdminClinicMember, isBecompleatMember, isSchool],
  );
};
